import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface routerTabsModel {
    patch:string,
    title:string,
    defaultTitle:string,
    keyPath:string[],
    formid:string,
    dynamicReportsId?:number,
}

interface commonModel {
    pathname: string,
    routerTabs: routerTabsModel[]
    activeMenuTab:string,
    openTabCount: number,
    unreadMailCount:number,
    lastUserMessageId:number,
}

const getRouterTabs = () => {
    const ls = localStorage.getItem('routerTabs');
    if(ls !== null){
        return JSON.parse(ls) as routerTabsModel[];
    }
    return [];
};

const getActiveTabKey = () => {
    const ls = localStorage.getItem('activeMenuTab');
    if(ls !== null){
        return ls as string;
    }
    return 'main' as string;
};

const initialState: commonModel = {
    pathname: '/',
    routerTabs: getRouterTabs(),
    activeMenuTab: getActiveTabKey(),
    unreadMailCount:0,
    lastUserMessageId:0,
    openTabCount: 30,
};

export const commonSlice = createSlice({
    name: "common",
    initialState: initialState,
    reducers: {
        setRouterTabsActiveKey: (state, action: PayloadAction<{routerTabs:routerTabsModel[], activeMenuTab: string}>) => {
            localStorage.setItem('routerTabs', JSON.stringify(action.payload.routerTabs || []));
            localStorage.setItem('activeMenuTab',action.payload.activeMenuTab || 'main');

            return {
                ...state,
                ...action.payload,
            };
        },
        setRouterTabs: (state, action: PayloadAction<routerTabsModel[]>) => {
            localStorage.setItem('routerTabs', JSON.stringify(action.payload || []));
            state.routerTabs = action.payload
        },
        setActiveTabKey: (state, action: PayloadAction<string>) => {
            localStorage.setItem('activeMenuTab', action.payload || 'main');
            return  {
                ...state,
                activeMenuTab: action.payload
            };
        },
        setUnreadMailCount: (state, action: PayloadAction<number>) => {
            return  {
                ...state,
                unreadMailCount: action.payload
            };
        },
        setLastUserMessageId: (state, action: PayloadAction<number>) => {
            state.lastUserMessageId = action.payload;
            return state;
           /* return  {
                ...state,
                lastUserMessageId: action.payload
            };*/
        },
    }
})

export const { setRouterTabs, setActiveTabKey, setLastUserMessageId,setUnreadMailCount,setRouterTabsActiveKey } = commonSlice.actions;

export default commonSlice.reducer;
